<template>
	<div class="product-relations caption-2" :class="getType" v-show="getProductsLength" ref="productRelations">
		<span :name="$el"> {{ getText }}</span>
		<tippy :to="$el" distance="8" placement="top" theme="product-relations-tooltip" :onShow="tippyScroll">
			<!-- more that one product -->
			<div v-if="getProductsLength > 1" class="multiple-products">
				<div>{{ getContent.message }}:</div>
				<ul>
					<li v-for="(prod, i) in getProducts" v-html="prod" :key="i" />
				</ul>
				<div v-if="getProductsLength > 5"><span>...</span></div>
			</div>

			<!-- only one product -->
			<div v-else v-html="`${getContent.message} ${getProducts[0]}`" />
		</tippy>
	</div>
</template>
<script>
export default {
	name: 'ProductRelations',
	props: {
		requiredBy: {
			type: Set,
		},
		exclusiveRequiredBy: {
			type: Set,
		},
		suggestedBy: {
			type: Set,
		},
	},
	data() {
		return {
			products: [],
			type: 'default',
			content: {
				default: {
					text: 'Required by other product',
					message: 'This product is required by',
				},
				suggestedBy: {
					text: 'Suggested by other product',
					message: 'Product is suggested when selected',
				},
			},
		};
	},
	watch: {
		$props: {
			handler() {
				for (const key in this.$props) if (this.$props[key]) return this.init([...this.$props[key]]);
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		async init(products) {
			this.products = await this.buildProducts(products);
		},
		async buildProducts(allProducts) {
			// only add products that are still selected in workflow
			const products = allProducts.filter((key) => this.checkForMissingProducts.includes(key));
			return Promise.all(products.map((key) => this.$store.getters['workflow/productName'](key)));
		},
		tippyScroll(activeTippyInstance) {
			window.addEventListener(
				'scroll',
				() => {
					activeTippyInstance.hide();
					activeTippyInstance.reference.blur();
				},
				{once: true},
			);
		},
	},
	computed: {
		checkForMissingProducts() {
			return this.$store.getters['workflow/allSelectedProductKeys'];
		},
		getContent() {
			return this.content[this.getType];
		},
		getText() {
			return this.getProductsLength > 1 ? `${this.getContent.text}s` : this.getContent.text;
		},
		getProductsLength() {
			return this.products?.length;
		},
		getProducts() {
			return this.products.slice(0, 5);
		},
		getType() {
			return this.suggestedBy ? 'suggestedBy' : 'default';
		},
	},
};
</script>
<style lang="scss">
.product-relations {
	color: $color-grey;
	background-color: $color-extra-light-grey;
	padding: 0 8px;
	border-radius: 8px;
	margin-bottom: 14px;
	&[class*='suggest'] {
		color: $color-mid-blue;
		background-color: $color-super-light-blue;
	}
	@media screen and (min-width: $mobile + 1) {
		display: inline-block;
		margin-bottom: 4.5px;
		&:first-of-type {
			margin-right: 10px;
		}
	}
}
.product-relations-tooltip-theme {
	@include font-styles('Futura W01 Book', 400);
	@include textStyles(13, 20, 0.4);
	padding: 0 8px;
	br {
		display: none;
	}
	.multiple-products {
		padding: 2px 0px;
		text-align: left;
		ul {
			padding-left: 20px;
			text-align: left;
			margin: 0;
			li {
				padding: 0px 0;
				br {
					display: none;
				}
			}
		}
	}
}
</style>
